<template>
  <div class="c-aed-pictures">
    <div
      class="o-heading o-heading--border o-grid o-grid--gutter-tiny o-grid--align-items-center"
    >
      <div class="o-grid__group">
        <div class="o-grid__item">
          <h3 class="o-heading o-heading--bold o-heading--size-3">
            {{ translationsPictures.sectionName || name }}
          </h3>
        </div>
      </div>
    </div>
    <div class="c-aed-pictures__list--noresults" v-if="!pictures.length">
      <h4 class="o-heading o-heading--size-4">
        {{ translationsPictures.noPictures }}
      </h4>
    </div>
    <div
      v-if="pictures.length > 0"
      class="c-aed-pictures__list o-grid o-grid--direction-row o-grid--gutter-small o-field o-field--border o-field--spacing-none"
    >
      <div class="o-grid__group">
        <div
          v-for="picture in pictures"
          :key="picture.pictureId"
          class="o-grid__item o-grid__item--2"
        >
          <div class="c-aed-pictures__picture">
            <CallCenterAEDpicture
              :src="picture.imageUrl"
            ></CallCenterAEDpicture>
            <div
              class="c-aed-pictures__actions o-grid o-grid--direction-row o-grid--gutter-tiny o-grid--justify-content-end"
            >
              <div class="o-grid__group">
                <div class="o-grid__item o-grid__item--grow-0">
                  <button
                    type="button"
                    class="o-button o-button--action o-button--round o-button--light"
                    :title="translationsPictures.addPicture || ''"
                    @click="deletePicture(picture)"
                    :disabled="isEditing !== null"
                  >
                    <svg
                      class="o-svg-icon o-button__icon"
                      viewBox="0 0 64 64"
                      type="image/svg+xml"
                    >
                      <use
                        xlink:href="spritemap.svg#sprite-delete"
                        x="0"
                        y="0"
                      ></use>
                    </svg>
                  </button>
                </div>
                <div class="o-grid__item o-grid__item--grow-0">
                  <button
                    type="button"
                    class="o-button o-button--action o-button--round o-button--light"
                    :title="translationsPictures.addPicture || ''"
                    @click="editPicture(picture)"
                    :disabled="isEditing !== null"
                  >
                    <svg
                      class="o-svg-icon o-button__icon"
                      viewBox="0 0 64 64"
                      type="image/svg+xml"
                    >
                      <use
                        xlink:href="spritemap.svg#sprite-edit"
                        x="0"
                        y="0"
                      ></use>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            class="c-aed-pictures__picture-name o-label"
            :title="picture.name || ''"
          >
            {{ picture.name || "" }}
          </div>
          <div
            class="c-aed-pictures__picture-text o-label"
            :title="picture.text || ''"
          >
            {{ picture.text || "" }}
          </div>
        </div>
      </div>
    </div>
    <div
      class="o-grid o-grid--gutter-large o-grid--padding-none o-grid--align-items-center o-field o-field--spacing-none o-field--border o-field--border-none"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--12">
          <button
            type="button"
            class="o-button o-button--transparent o-button--clean"
            :title="translationsPictures.addPicture || ''"
            @click="initiateUpload"
            :disabled="isEditing !== null"
          >
            <svg
              class="o-svg-icon o-button__icon o-button__icon--action  o-button__icon--shadow o-button__icon--round"
              viewBox="0 0 64 64"
              type="image/svg+xml"
            >
              <use xlink:href="spritemap.svg#sprite-plus" x="0" y="0"></use>
            </svg>
            <span>{{ translationsPictures.addPicture || "" }}</span>
          </button>
          <input
            class="u-visually-hidden"
            tabIndex="-1"
            type="file"
            accept="image/*"
            ref="uploadPicture"
            @change="fileUploaded($event.target.files[0])"
          />
        </div>
      </div>
    </div>
    <transition name="o-transition__modal">
      <CallCenterAEDModal v-if="showEditModal" @close="closeModal">
        <h2
          class="o-heading o-heading--size-2 o-heading--section o-heading--border"
          slot="header"
        >
          {{ translationsPictures.editOrChangePicture }}
        </h2>
        <div slot="body">
          <div
            class="c-modal-picture__picture-controll o-grid o-grid--gutter-normal o-grid--padding-none o-grid--align-items-center"
          >
            <div class="o-grid__group">
              <div class="o-grid__item o-grid__item--12">
                <v-cropper
                  ref="cropper"
                  :src="cropperSource"
                  alt="Source Image"
                  :viewMode="2"
                  :minContainerWidth="530"
                  :minContainerHeight="320"
                  :zoomable="false"
                  :guides="true"
                  drag-mode="crop"
                  :auto-crop-area="1"
                  :background="true"
                  :aspectRatio="16 / 9"
                  :rotatable="true"
                  class="c-cropper"
                ></v-cropper>
                <!-- <img :src="croppedImage" style="width: 200px; height: 150px;" /> -->
              </div>
              <div class="o-grid__item o-grid__item--12">
                <div
                  class="c-modal-picture__picture-actions o-grid o-grid--gutter-normal o-grid--padding-none o-grid--justify-content-center o-grid--align-items-center"
                >
                  <div class="o-grid__group">
                    <div class="o-grid__item o-grid__item--grow-0">
                      <button
                        class="o-button o-button--transparent o-button--stack"
                        @click="rotatePicture"
                        type="button"
                      >
                        <svg
                          class="o-svg-icon o-button__icon o-button__icon--stack"
                          viewBox="0 0 64 64"
                          type="image/svg+xml"
                        >
                          <use
                            xlink:href="spritemap.svg#sprite-rotate-simple"
                            x="0"
                            y="0"
                          ></use>
                        </svg>
                        <span>{{
                          translationsPictures.rotatePicture || ""
                        }}</span>
                      </button>
                    </div>

                    <button
                      class="c-modal-picture__change-image o-button o-button--small o-button--light o-button--shadow"
                      @click="initiateUpload"
                      type="button"
                    >
                      <svg
                        class="o-svg-icon o-button__icon"
                        viewBox="0 0 64 64"
                        type="image/svg+xml"
                      >
                        <use
                          xlink:href="spritemap.svg#sprite-edit"
                          x="0"
                          y="0"
                        ></use>
                      </svg>
                      <span>{{
                        translationsPictures.changePicture || ""
                      }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="c-modal-picture__inputs-wrap o-grid o-grid--gutter-normal o-grid--padding-none o-grid--align-items-center"
          >
            <div class="o-grid__group">
              <div class="o-grid__item o-grid__item--12">
                <h4
                  class="c-modal-comment__text-label o-heading o-heading--size-4 o-label o-label--block"
                >
                  {{ translationsPictures.pictureHeading || "" }}
                </h4>
                <input
                  class="o-input o-input--modal"
                  type="text"
                  v-model="mutableObject.name"
                  :placeholder="translationsCustom.addValue || ''"
                />
              </div>
              <div class="o-grid__item o-grid__item--12">
                <h4
                  class="c-modal-comment__text-label o-heading o-heading--size-4 o-label o-label--block"
                >
                  {{ translationsPictures.pictureDescription || "" }}
                </h4>
                <textarea
                  class="c-modal-picture__textarea o-input o-input--modal"
                  name="comment"
                  :placeholder="translationsCustom.addValue || ''"
                  v-model="mutableObject.text"
                  id=""
                  cols="30"
                  rows="10"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
        <div slot="footer">
          <div
            class="o-grid o-grid--direction-column o-grid--gutter-tiny o-grid--align-items-center"
          >
            <div class="o-grid__group">
              <div class="o-grid__item o-grid__item--grow-0">
                <button class="o-button" @click="savePicture">
                  {{ translationsPictures.savePicture }}
                </button>
              </div>
              <div class="o-grid__item o-grid__item--grow-0">
                <button
                  class="o-button o-button--transparent"
                  @click="closeModal"
                >
                  {{ translationsCustom.cancel || "" }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </CallCenterAEDModal>
    </transition>
    <transition name="o-transition__modal">
      <CallCenterAEDModal v-if="showDeleteModal" @close="closeModal">
        <h2
          class="o-heading o-heading--size-2 o-heading--section o-heading--border"
          slot="header"
        >
          {{ translationsPictures.areYouSureToDeletePicture }}
        </h2>
        <div slot="footer">
          <div class="o-grid o-grid--gutter-small">
            <div class="o-grid__group">
              <div class="o-grid__item o-grid__item--grow-0">
                <button class="o-button" @click="deleteItem">
                  {{ translationsPictures.yesDeletePicture }}
                </button>
              </div>
              <div class="o-grid__item o-grid__item--grow-0">
                <button
                  class="o-button o-button--transparent"
                  @click="closeModal"
                >
                  {{ translationsCustom.cancel || "" }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </CallCenterAEDModal>
    </transition>
  </div>
</template>

<script>
import "cropperjs/dist/cropper.css";
import Tiff from "tiff.js";
import { mapState, mapGetters } from "vuex";

export default {
  name: "c-aed-pictures",
  data() {
    return {
      section: "pictures",
      name: "",
      isEditing: null,
      uploadImage: null,
      showEditModal: false,
      showDeleteModal: false,
      mutableObject: null,
      croppedImage: null
    };
  },
  computed: {
    ...mapState("translations", {
      translationsPictures: "pictures",
      translationsCustom: "custom"
    }),
    ...mapGetters("aed", ["pictures", "defaultPicture"]),
    cropperSource() {
      return this.uploadImage
        ? this.uploadImage
        : this.mutableObject
        ? `${this.$api}${this.mutableObject.imageUrl}`
        : null;
    }
  },
  methods: {
    initiateUpload() {
      this.$refs.uploadPicture.click();
    },
    handleFile(file) {
      if (typeof file == "string" && file.includes("image/")) {
        return file;
      }

      return new Tiff({ buffer: file }).toCanvas().toDataURL();
    },
    readFileAs(reader, file) {
      if (file.type === "image/tiff") {
        return reader.readAsArrayBuffer(file);
      }

      return reader.readAsDataURL(file);
    },
    fileUploaded(file) {
      if (!file.type.includes("image/")) {
        return alert(`${this.translationsPictures.pleaseSelectImageFile}`);
      }

      if (typeof FileReader !== "function") {
        return alert(`${this.translationsPictures.fileReaderAPInotSupported}`);
      }

      const reader = new FileReader();

      reader.onload = ({ target }) => {
        this.uploadImage = this.handleFile(target.result);

        if (this.mutableObject && this.showEditModal) {
          //If we do have editable object it is REUPLOAD and we replace picture
          this.$refs.cropper.replace(this.cropperSource);
        } else {
          //If we dont it NEW SUBMIT and we create editable object and open modal
          this.editPicture();
        }
      };

      this.readFileAs(reader, file);
    },
    editPicture(picture) {
      this.mutableObject = picture
        ? JSON.parse(JSON.stringify(picture))
        : JSON.parse(JSON.stringify(this.defaultPicture));
      this.showEditModal = true;
    },

    deletePicture(picture) {
      this.mutableObject = JSON.parse(JSON.stringify(picture));
      this.showDeleteModal = true;
    },
    deleteItem() {
      const { dispatch } = this.$store;
      const payload = {
        api: this.$api,
        method: "DELETE",
        section: this.section,
        id: this.$store.state.aed.all.id,
        itemId: this.mutableObject.pictureId
      };
      dispatch("aed/deletePictureItem", payload);

      this.closeModal();
    },
    closeModal() {
      this.showEditModal = false;
      this.showDeleteModal = false;
      this.mutableObject = null;
      this.croppedImage = null;
      this.uploadImage = null;
      this.$refs.uploadPicture.value = "";
    },
    rotatePicture() {
      this.$refs.cropper.rotate(90);
    },
    savePicture() {
      var canvas = this.$refs.cropper.getCroppedCanvas({
        maxWidth: 4096,
        maxHeight: 4096
      });
      var dataUri = canvas.toDataURL("image/jpeg");
      var base64encodedImage = dataUri.substr(dataUri.indexOf(",") + 1);
      const { dispatch } = this.$store;
      this.mutableObject.image = base64encodedImage;

      const payload = {
        api: this.$api,
        section: this.section,
        id: this.$store.state.aed.all.id,
        itemId: this.mutableObject.pictureId,
        data: this.mutableObject
      };
      this.mutableObject.pictureId === 0
        ? dispatch("aed/pushItem", payload)
        : dispatch("aed/putItem", payload);

      this.closeModal();
    }
  }
};
</script>
<style lang="scss">
.c-aed-pictures {
  &__list {
    padding: toRem(30px 0);
    &--noresults {
      font-style: italic;
      padding: toRem(20px 0 10px);
    }
  }
  &__picture {
    margin-bottom: toRem(5px);
    position: relative;
  }
  &__picture-name {
    color: $s-cp-main;
  }
  &__picture-text {
    @include setStyles("12", $s-typography-sizes);
  }
  &__actions {
    position: absolute;
    top: toRem(10px);
    right: toRem(10px);
  }

  .o-input {
    width: 100%;
  }
}
.c-cropper {
  max-height: 320px;
}

.c-modal-picture {
  &__picture-controll {
    border-bottom: 1px solid $s-cp-neutral-600;
    padding-bottom: toRem(20px);
    margin-bottom: toRem(25px);
  }
  &__picture-actions {
    position: relative;
  }
  &__change-image {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  &__inputs-wrap {
    max-width: 400px;
    margin: 0 auto 30px;
  }
  &__textarea {
    height: 80px;
  }
}
</style>
